import Music from "@components/Collection/artist/music";

export default Music;
